import { render, staticRenderFns } from "./CompanyBankForm.vue?vue&type=template&id=6c3cd5c7"
import script from "./CompanyBankForm.vue?vue&type=script&lang=js"
export * from "./CompanyBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports